export default "__VITE_ASSET__DXM798X$__"